import { Card, CardBody, CardHeader } from "reactstrap";
import Chart from "react-apexcharts";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRevenueAndExpenses } from "../../slices/adminDashboardRevenus-Expense/thunk";

const options = {
  chart: {
    type: "bar",
    stacked: true,
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "30px",
    },
  },
  colors: ["#30A998", "#E24444"],
  xaxis: {
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  },
  legend: {
    position: "top",
    horizontalAlign: "center",
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    borderColor: "#e7e7e7",
  },
};


export const RevenueGraph = () => {
  const dispatch = useDispatch();
const { monthlyData, loading } = useSelector((state) => state.RevenueAndExpenses);

useEffect(() => {
  dispatch(fetchRevenueAndExpenses());
}, [dispatch]);

const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const revenueData = new Array(12).fill(0);
const expensesData = new Array(12).fill(0);

monthlyData.forEach(item => {
  const index = months.indexOf(item.month);
  if (index !== -1) {
    revenueData[index] = parseFloat(item.revenue);
    expensesData[index] = parseFloat(item.expenses);
  }
});


const series = [
  {
    name: "Revenue",
    data: revenueData,
  },
  {
    name: "Expenses",
    data: expensesData,
  },
];

  return (
    <Card className="revenueCard mt-2 mt-sm-4">
      <CardBody>
        <CardHeader className="revenueCardHeader">
          Revenue And Expenses
        </CardHeader>

        <Chart options={options} series={series} type="bar" height={300} />
      </CardBody>
    </Card>
  );
};
